module.exports = __webpack_public_path__ + "static/another_zombie_game_logo_white_zombie-f87097e8197d74ad4a15e5a734b3a888.png";